<template>
	<v-sheet elevation="0">
		<FunctionTitle :title="'台帳'" />
		<CommonFlame :title="'台帳一覧'">
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<v-spacer />
				<v-btn color="primary" @click="toggleOwnDepartments">
					<v-icon class="mr-2">mdi-swap-horizontal</v-icon>
					<template v-if="own_departments">全ての台帳を表示</template>
					<template v-else>所属部門の台帳のみを表示</template>
				</v-btn>
				<v-btn
					color="primary"
					v-if="authorized"
					class="ml-2"
					@click="$router.push({ name: 'ledger_new' })"
				>
					<v-icon class="mr-2">mdi-plus</v-icon> 台帳作成</v-btn
				>
			</template>

			<template v-if="$vuetify.breakpoint.xs">
				<v-row no-gutters justify="end">
					<v-btn class="mb-2" color="secondary" @click="toggleOwnDepartments">
						<v-icon class="mr-2">mdi-swap-horizontal</v-icon>
						<template v-if="own_departments">全ての台帳を表示</template>
						<template v-else>所属部門の台帳のみを表示</template>
					</v-btn>
					<v-btn
						color="secondary"
						v-if="authorized"
						class="ml-2 mb-2"
						@click="$router.push({ name: 'ledger_new' })"
					>
						<v-icon class="mr-2">mdi-plus</v-icon> 台帳作成</v-btn
					>
				</v-row>
			</template>

			<div class="table-container">
				<v-data-table
					locale="ja-JP"
					:headers="headers"
					:items="ledgers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr
							@click="$router.push({ name: 'ledger_show', params: { id: item.id } })"
							class="clickable"
						>
							<td>{{ item.name }}</td>
							<td>{{ item.department ? item.department.name : ''}}</td>
							<td>{{ item.locale_model_name }}</td>
							<td>{{ item.user.full_name }}</td>
							<td>{{ datetimeFormat(item.created_at) }}</td>
							<td>{{ datetimeFormat(item.updated_at) }}</td>
						</tr>
					</template>
				</v-data-table>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)" /> </CommonFlame
	></v-sheet>
</template>

<script>
import axios from "axios"
import moment from "moment/min/moment.min.js"
import errorHandling from "../../helper/errorHandling"
import authenticate from "../../helper/authenticate"
import PaginationModule from "../shared/PaginationModule.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"

export default {
	components: {
		PaginationModule,
		FunctionTitle,
		CommonFlame,
	},
	data() {
		return {
			ledgers: [],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			own_departments: false,
			authorized: false,
			headers: [
				{ text: "台帳名", value: "name", width: "200px", divider: true },
				{ text: "部門", value: "department.name", width: "200px", divider: true },
				{ text: "参照データ", value: "locale_model_name", width: "200px", divider: true },
				{ text: "最終変更ユーザー", value: "user.full_name", width: "200px", divider: true },
				{ text: "作成日", value: "created_at", width: "150px", divider: true },
				{ text: "最終変更日", value: "updated_at", width: "150px", divider: true },
			],
		}
	},
	mounted() {
		authenticate.authenticateUser()
		const page = this.$route.query.page ? this.$route.query.page : 1
		if (this.$route.query.own_departments) {
			this.own_departments = this.$route.query.own_departments == "false" ? false : true
		}
		this.fetchLedgers(page)
	},
	methods: {
		fetchLedgers(page) {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/ledgers`
			axios
				.get(url, { headers, params: { page, own_departments: this.own_departments } })
				.then((res) => {
					this.ledgers = res.data.ledgers
					this.pagination = res.data.pagination
					this.authorized = res.data.authorized
				})
				.catch((err) => errorHandling.errorResponse(err))
		},
		getPage(i) {
			this.fetchLedgers(i)
			this.$router.push({
				name: "ledger_index",
				query: { own_departments: this.own_departments, page: i },
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		toggleOwnDepartments() {
			this.own_departments = !this.own_departments
			this.fetchLedgers(1)
			this.$router.push({
				name: "ledger_index",
				query: { own_departments: this.own_departments, page: 1 },
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
	},
	computed: {
		datetimeFormat() {
			return (datetime) => {
				if (!datetime) return null
				return moment(datetime).format("YYYY/MM/DD HH:mm")
			}
		},
	},
}
</script>

<style lang="scss" scoped>
@import "../../stylesheet/variable.scss";

.table-container {
	width: 100%;
	overflow-x: scroll;
	.v-data-table {
		width: auto;
	}
}
.container-with-border {
	border: $border-line;
	border-radius: 4px;
}
.app-bar-btn {
	background-color: $common-back-color !important;
	color: $main-color !important;
}
</style>